/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGitPush = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5 14.126A4.002 4.002 0 0 0 6 22a4 4 0 0 0 1-7.874V2H5zM14 6a4 4 0 1 1 5 3.874V19h-7v-2h5V9.874A4.002 4.002 0 0 1 14 6zm4-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM6 16a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgGitPush as GitPush };
